module.exports = __webpack_public_path__ + "static/media/img26.215226b4.jpg";